import React, {useEffect, useState, useRef} from 'react';
import Navigation from './Navigation';
import {connect} from 'react-redux';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import CreatePostModal from './modals/CreatePostModal';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import logo from './Images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import SideNav from './SideNav';
import JoinModal from './modals/JoinModal';
import LoginModal from './modals/LoginModal';
import UserPostCard from './UserPostCard';
import { FaCog } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import UsersProfilePostCard from './UsersProfilePostCard';
import userimage from './Images/user.png';



function Profile({currentUser}) {
    const navigate = useNavigate();
    const myElementRef = useRef();
    const[isCreatePostModalVisible, setIsCreatePostModalVisible] = useState(false);
    const[showDropdownPage, setShowDropdownPage] = useState(false);  
    const[isLoggedIn, setIsLoggedIn] = useState(false);
    const[isJoinModalVisible, setIsJoinModalVisible] = useState(false);
    const[isLoginModalVisible, setIsLoginModalVisible] = useState(false);
    const[navHeight, setNavHeight] = useState(0);

    const[userInfo, setUserInfo] = useState([]);

    const[text, setText] = useState('')

    const handleTextChange = (event) => {
        setText(event.target.value)
    }

    const location = useLocation();
    const dataPassedParams = new URLSearchParams(location.search);
    const idPassed = dataPassedParams.get('id');
    //console.log(idPassed)

    
      

    const fetchData = async () => {
        firebase.firestore()
        .collection('users')
        .doc(idPassed)
        .get()
        .then((snapshot) => {
            if (snapshot.exists) {
                setUserInfo(snapshot.data())
            } else {
                console.log('User does not exist');
            }
        });
    }

    useEffect(() => {
        const element = myElementRef.current;
        const height = element.offsetHeight;
        setNavHeight(height);
       if (showDropdownPage === true) {
            document.querySelector('.profile-body').classList.add('no-scroll');
        } else {
            document.querySelector('.profile-body').classList.remove('no-scroll');
        }
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
              setIsLoggedIn(false)
            } else {
              setIsLoggedIn(true)
            }
        })
        if(idPassed) {
            fetchData()
        }
    }, [showDropdownPage, isLoggedIn])

    const search = (event) => {
        navigate('/search', {state:{text: text}});
        event.preventDefault()
      }
    return(
        <div>
            <div>
                <Navbar bg="" expand="lg" className="navbar feed-navbar" ref={myElementRef}>
                    <Container fluid className="header">
                        <Navbar.Brand href="/" className="logo"><img src={logo} alt="Cuisn Logo" className="logo"></img></Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" className="toggle-button" onClick={() => {if (window.innerWidth <= 991) {setShowDropdownPage(!showDropdownPage)}}}/>
                        <Navbar.Collapse id="basic-navbar-nav" className='basic-navbar-nav'>
                            <div className='mr-auto'>
                                <div className='header-input-inner-div'>
                                    <form onSubmit={search}>
                                        <Row>
                                            <Col xs={12} sm={12} md={9} lg={9}>
                                                <input placeholder='Tacos, Chef Lanez, Bistros, Culinary School, Utensils' className='header-input header-type-input top-nav-input' value={text} onChange={handleTextChange}></input>
                                            </Col>
                                            <Col xs={12} sm={12} md={3} lg={3}>
                                                <button className='header-search-button nav-search-button' type='submit' name='submit'>Search</button>
                                            </Col>
                                        </Row>
                                    </form>
                                </div>
                            </div>
                            <Nav className="ms-auto">
                                {!isLoggedIn ? 
                                    <div>
                                        <button className="nav-links community create mobile-fix-navbar-create" onClick={() => {setIsLoginModalVisible(true)}}>Log In</button>
                                        <button className="nav-links community create waitlist home-signup" onClick={() => {setIsJoinModalVisible(true)}}>Sign Up</button>
                                    </div> : 
                                    <div>
                                        <Link to='/account/settings'><FaCog style={{color: 'grey', marginRight: '30px', height: '25px', width: '25px'}}/></Link>
                                        {(currentUser.image === '') ? <img src={userimage} alt=''className='feed-card-user-image'></img> : <img src={currentUser.image} alt=''className='feed-card-user-image'></img>}
                                    </div>
                                }
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
            <div className='profile-body'>
                <Container>
                    <Row>
                        <Col lg={4} md={4} sm={0} xs={0} className='profile-small-screen-col'>
                            {idPassed ? 
                                <div className='profile-side-div'>
                                    {(userInfo.image === '') ? 
                                        <img src={userimage} alt=''className='profile-user-image'></img> : 
                                        <img src={userInfo.image} alt=''className='profile-user-image'></img>
                                    }
                                    <p className='profile-name'>{userInfo.name}</p>
                                    <span className='profile-username'>@{userInfo.username}</span>
                                    {(userInfo.role === 'foodie') ? <p>Foodie</p> : null}
                                    {(userInfo.role === 'chef') ? <p>Chef</p> : null}
                                    {(userInfo.role === 'restaurant') ? <p>Restaurant</p> : null}
                                    {(userInfo.role === 'food-blogger') ? <p>Food blogger</p> : null}
                                    {(userInfo.role === 'food-content-creator') ? <p>Food content creator</p> : null}
                                    {(userInfo.role === 'food-items-vendor') ? <p>Food items vendor</p> : null}
                                </div> :
                                <div className='profile-side-div'>
                                    {(currentUser.image === '') ? <img src={userimage} alt=''className='profile-user-image'></img> : <img src={currentUser.image} alt=''className='profile-user-image'></img>}
                                    <p className='profile-name'>{currentUser.name}</p>
                                    <span className='profile-username'>@{currentUser.username}</span>
                                    {(currentUser.role === 'foodie') ? <p>Foodie</p> : null}
                                    {(currentUser.role === 'chef') ? <p>Chef</p> : null}
                                    {(currentUser.role === 'restaurant') ? <p>Restaurant</p> : null}
                                    {(currentUser.role === 'food-blogger') ? <p>Food blogger</p> : null}
                                    {(currentUser.role === 'food-content-creator') ? <p>Food content creator</p> : null}
                                    {(currentUser.role === 'food-items-vendor') ? <p>Food items vendor</p> : null}
                                </div>
                            } 
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            {idPassed ? <UsersProfilePostCard idPassed={idPassed} isLoggedIn={isLoggedIn}/> : <UserPostCard isLoggedIn={isLoggedIn}/>}
                        </Col>
                        <Col lg={4} md={4} sm={0} xs={0} className='profile-large-screen-col'>
                            {idPassed ? 
                                <div className='profile-side-div'>
                                    {(userInfo.image === '') ? <img src={userimage} alt=''className='profile-user-image'></img> : <img src={userInfo.image} alt=''className='profile-user-image'></img>}
                                    <p className='profile-name'>{userInfo.name}</p>
                                    <span className='profile-username'>@{userInfo.username}</span>
                                    {(userInfo.role === 'foodie') ? <p>Foodie</p> : null}
                                    {(userInfo.role === 'chef') ? <p>Chef</p> : null}
                                    {(userInfo.role === 'restaurant') ? <p>Restaurant</p> : null}
                                    {(userInfo.role === 'food-blogger') ? <p>Food blogger</p> : null}
                                    {(userInfo.role === 'food-content-creator') ? <p>Food content creator</p> : null}
                                    {(userInfo.role === 'food-items-vendor') ? <p>Food items vendor</p> : null}
                                </div> :
                                <div className='profile-side-div'>
                                    {(currentUser.image === '') ? <img src={userimage} alt=''className='profile-user-image'></img> : <img src={currentUser.image} alt=''className='profile-user-image'></img>}
                                    <p className='profile-name'>{currentUser.name}</p>
                                    <span className='profile-username'>@{currentUser.username}</span>
                                    {(currentUser.role === 'foodie') ? <p>Foodie</p> : null}
                                    {(currentUser.role === 'chef') ? <p>Chef</p> : null}
                                    {(currentUser.role === 'restaurant') ? <p>Restaurant</p> : null}
                                    {(currentUser.role === 'food-blogger') ? <p>Food blogger</p> : null}
                                    {(currentUser.role === 'food-content-creator') ? <p>Food content creator</p> : null}
                                    {(currentUser.role === 'food-items-vendor') ? <p>Food items vendor</p> : null}
                                </div>
                            }  
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={`feed-side-nav ${showDropdownPage ? 'slide-in' : ''}`} style={{top: `${navHeight}px`}}>
                <SideNav isLoggedIn={isLoggedIn} setIsJoinModalVisible={setIsJoinModalVisible} setIsLoginModalVisible={setIsLoginModalVisible}/>
            </div>
            <Navigation setIsCreatePostModalVisible={setIsCreatePostModalVisible} isCreatePostModalVisible={isCreatePostModalVisible} isLoggedIn={isLoggedIn}></Navigation>
            <CreatePostModal isCreatePostModalVisible={isCreatePostModalVisible} setIsCreatePostModalVisible={setIsCreatePostModalVisible}></CreatePostModal>
            <JoinModal isJoinModalVisible={isJoinModalVisible} setIsJoinModalVisible={setIsJoinModalVisible} setIsLoginModalVisible={setIsLoginModalVisible} isLoginModalVisible={isLoginModalVisible}/>
            <LoginModal isLoginModalVisible={isLoginModalVisible} setIsLoginModalVisible={setIsLoginModalVisible} setIsJoinModalVisible={setIsJoinModalVisible} isJoinModalVisible={isJoinModalVisible}/>
        </div>
    );
}
const mapStateToProps = (state) => ({
    currentUser: state.currentUser
})
export default connect(mapStateToProps, null)(Profile);